export const collaboratorRole = [
  'adv',
  'adv-distanciel',
  'responsable-magasin',
  'chef-secteur',
  'responsable-regional-reseau',
  'responsable-animation-ventes-distance',
  'agent-de-securite',
] as const
export type CollaboratorRole = (typeof collaboratorRole)[number]

export const collaboratorRoleLabel: Record<CollaboratorRole, string> = {
  adv: 'Animateur des Ventes',
  'adv-distanciel': 'Animateur des Ventes - Distanciel',
  'responsable-magasin': 'Manager de Boutiques',
  'chef-secteur': 'Responsable de Secteur',
  'responsable-regional-reseau': 'Responsable régional de réseau',
  'responsable-animation-ventes-distance': 'Responsable animation des ventes à distance',
  'agent-de-securite': 'Agent de sécurité',
}

// Rôles au sommet de la hiérarchie (directeur / gérant) : pas de N+1 obligatoire.
// Pour tous les autres rôles, le manager (managerId) reste requis.
export const rolesWithoutMandatoryManager: CollaboratorRole[] = [
  'responsable-magasin',
  'chef-secteur',
  'responsable-regional-reseau',
]
